export enum MFA_LEVELS {
	ACCESS_LEVEL = 'accessLevel',
	COMPANY = 'company',
	USER_OPT_IN = 'userOptIn',
}
